import { z } from "zod";

export const KronosCachedGroup = z.object({
  model: z.string(),
  signature: z.string(),
  count: z.number(),
  last_precomputed_at: z.string().nullable(),
  decision_times: z.array(z.number()),
});
export type KronosCachedGroup = z.infer<typeof KronosCachedGroup>;

export const KronosJob = z.object({
  id: z.string(),
  market_id: z.string(),
  model: z.string(),
  decision_times: z.array(z.number()),
  signature: z.string(),
  status: z.enum(["running", "succeeded", "failed", "cancelled"]),
  started_at: z.string(),
  finished_at: z.string().nullable(),
  written: z.number().nullable(),
  message: z.string().nullable(),
});
export type KronosJob = z.infer<typeof KronosJob>;

export const KronosMarketStatus = z.object({
  market_id: z.string(),
  window_seconds: z.number(),
  enabled: z.boolean(),
  active: z
    .object({
      has_config: z.boolean(),
      kronos_check_enabled: z.boolean(),
      model: z.string(),
      signature: z.string(),
      decision_time_seconds: z.number(),
    })
    .nullable(),
  active_cached: KronosCachedGroup.nullable(),
  cached: z.array(KronosCachedGroup),
  job: KronosJob.nullable(),
});
export type KronosMarketStatus = z.infer<typeof KronosMarketStatus>;

export const KronosStatusResponse = z.object({ items: z.array(KronosMarketStatus) });
export type KronosStatusResponse = z.infer<typeof KronosStatusResponse>;

/** One selectable precomputed cache = a signature at a decision time. */
export const KronosSignatureInfo = z.object({
  market_id: z.string(),
  decision_time_seconds: z.number(),
  signature: z.string(),
  model: z.string(),
  lookback: z.number(),
  timeframe: z.number(),
  sample_count: z.number(),
  temperature: z.number(),
  top_p: z.number(),
  settled: z.boolean(),
  count: z.number(),
  window_start_min: z.string().nullable(),
  window_start_max: z.string().nullable(),
  last_precomputed_at: z.string().nullable(),
});
export type KronosSignatureInfo = z.infer<typeof KronosSignatureInfo>;

export const KronosSignaturesResponse = z.object({ items: z.array(KronosSignatureInfo) });
export type KronosSignaturesResponse = z.infer<typeof KronosSignaturesResponse>;
